const maskMode = {
  name: "mask-mode",
  path: "mask-mode",
  title: "mask-mode",
  description: "Utilities for controlling the CSS mask-mode property.",
  value: {
    "mask-mode": {
      "mask-alpha": "alpha",
      "mask-luminance": "luminance",
      "mask-match": "match-source"
    }
  },
      exampleData: [
        {
            "title": "mask-alpha, mask-luminance",
            "description": "utilities to control the mode of an element's mask:",
            "moreDescription": "",
            "parentClass": "!bg-none !border-0 py-5 grid grid-columns-1 gap-y-20 !mt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "text": "mask-alpha",
                        "textClass": "absolute  whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"aspect-3/1 mask-alpha border w-full mask-center rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[linear-gradient(to_right,black,_transparent)] bg-cover bg-center"
                    },  
                    {
                        "text": "mask-luminance",
                        "textClass": "absolute  whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",
                        "divClass":"aspect-3/1 mask-luminance border w-full mask-center rounded-lg bg-image-[url(https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo)] mask-image-[linear-gradient(to_right,white,_black)] bg-cover bg-center"
                    },                   
                ],
                "className": "relative",
                "code": `<div class="mask-alpha mask-image-[linear-gradient(to_right,black,_transparent)] bg-image-[url(/img/mountains.jpg)] ..."></div>
<div class="mask-luminance mask-image-[linear-gradient(to_right,white,_black)] bg-image-[url(/img/mountains.jpg)] ..."></div>`
            }
        }
    ]
};

export default maskMode;